<template>

    <slick ref="slickfive" v-if="this.slider.length" :options="slickOptions" >
     
        <a :href="item.url" v-for="(item,i) in this.slider" :key="i" class="w-100" @click="(e)=> dragging && e.preventDefault()">
          <PuSkeleton v-if="!item.image" style="width:100%;height:450px" />
         <responsive-image
        v-else
          v-bind:desktop="`${$root.image_url_c}inside/1300x450/${item.image}`"
          v-bind:tab="`${$root.image_url_c}inside/600x280/${item.image}`"
          v-bind:mobile="`${$root.image_url_c}inside/650x280/${item.image}`"
          v-bind:default_image="`${$root.image_url_c}inside/1300x450/${item.image}`"
          
          custom_class="w-100"
         />
        </a>
        
        
    </slick>
 

  <!-- <section v-if="this.$store.state.Banner.length">
    <slick ref="slick" :options="slickOptions">
      <a :href="item.url" v-for="(item,i) in this.$store.state.Banner" :key="i" ><img :src="item.image" :alt="item.title" :title="item.title" class="w-100"></a>
    </slick>  -->
  <!-- </section> -->
</template>
<style>
@import '../../../node_modules/slick-carousel/slick/slick.css';
.w-100{
  width: 100%;
  /* z-index: -1; */
}
.slick-dotted.slick-slider {
    margin-bottom: -5px;
}

@media screen and (max-width: 767px) {
/* .w-100 {
    min-height: 196px !important;
} */

}
</style>

<script>
import slick from 'vue-slick'
import axios from 'axios'
// import  s from "node_modules/Kartmax-technology"
 
 
export default { 
  name: 'banner',
    components: { slick ,
     
    },
    props: ["slider"],
    mounted(){
      // this.get_banner();
    },
    methods:{
        //   get_banner(){
            
        //     axios.get(this.$root.api_url + `/pim/pimresponse.php?service=banner_slider&store=${this.$root.store}`)
        //     .then(response => {
        //         this.slider = response.data.result.mainbanner;
        //         this.$root.midBanner = response.data.result.midbanner
        //         this.$root.bottomBanner = response.data.result.bottombanner
        //         this.slider_show = true;
        //     })
        // },


    },
    data() {
        return {
          image_url_c: 'https://devimages.popularshoemart.com/',
          slider:'',
          slider_show:false,
          dragging: false,
          slickOptions: {
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    pauseOnFocus: false,
                    pauseOnHover: false,
                    pauseOnDotsHover: true,
                    arrows: false,
                    dots:true,
                    beforeChange: () => this.dragging = true,
                    afterChange: () => this.dragging = false,
                     "responsive": [
                {
                  "breakpoint": 1024,
                  "settings": {
                   
                    "dots": true
                  }
                },
                {
                  "breakpoint": 767,
                  "settings": {
                   
                    "dots":false

                  }
                },
                {
                  "breakpoint": 480,
                  "settings": {
                    "dots":false
                  }
                }
              ]
                    // Any other options that can be got from plugin documentation
                },
            
            // slickOptions: {
            //   slidesToShow: 1,
            //   autoplay: true,
            //   autoplaySpeed: 2000,
            //   pauseOnFocus: false,
            //   pauseOnHover: true,
            //   pauseOnDotsHover: true,
            //   dots: true,
            //   infinite: false,
            //   speed: 500,
             
            //   "initialSlide": 0,
            //   "responsive": [
            //     {
            //       "breakpoint": 1024,
            //       "settings": {
            //         "slidesToShow": 3,
            //         "slidesToScroll": 3,
            //         "infinite": true,
            //         "dots": true
            //       }
            //     },
            //     {
            //       "breakpoint": 600,
            //       "settings": {
            //         "slidesToShow": 2,
            //         "slidesToScroll": 2,
            //         "initialSlide": 2
            //       }
            //     },
            //     {
            //       "breakpoint": 480,
            //       "settings": {
            //         "slidesToShow": 1,
            //         "slidesToScroll": 1
            //       }
            //     }
            //   ]
            // }
        };
    },
}
</script>